
import { Event } from "@/lib/types";
import { CalendarDays, Clock, MapPin } from "lucide-react";

interface EventHeaderProps {
  event: Event;
}

export const EventHeader = ({ event }: EventHeaderProps) => {
  // Parse the date without timezone conversion
  const rawDate = new Date(event.date);
  const formattedDate = `${rawDate.toLocaleString('en-US', { 
    weekday: 'short',
    day: 'numeric', 
    month: 'short', 
    year: 'numeric',
    timeZone: 'UTC' // Use UTC to prevent local timezone conversion
  })}`;
  
  return (
    <>
      <div className="bg-white rounded-t-lg p-8">
        <h1 className="text-5xl font-bold text-black leading-tight">
          {event.title}
        </h1>
      </div>

      <div className="bg-white border-y border-gray-200 p-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="flex items-start space-x-4">
            <CalendarDays className="h-6 w-6 text-gray-600 mt-1" />
            <div>
              <p className="text-sm text-gray-600 font-medium">Date</p>
              <p className="text-lg text-black">{formattedDate}</p>
              {event.date_extra_note && (
                <p className="text-sm text-gray-600 italic">{event.date_extra_note}</p>
              )}
            </div>
          </div>

          <div className="flex items-start space-x-4">
            <Clock className="h-6 w-6 text-gray-600 mt-1" />
            <div>
              <p className="text-sm text-gray-600 font-medium">Time</p>
              <p className="text-lg text-black">{event.event_time_range || 'Time TBA'}</p>
              {event.event_time_note && (
                <p className="text-sm text-gray-600 italic">{event.event_time_note}</p>
              )}
            </div>
          </div>

          <div className="flex items-start space-x-4">
            <MapPin className="h-6 w-6 text-gray-600 mt-1" />
            <div>
              <p className="text-sm text-gray-600 font-medium">Location</p>
              {event.location_url ? (
                <a 
                  href={event.location_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-lg text-purple-600 hover:text-purple-800"
                >
                  {event.location}
                </a>
              ) : (
                <p className="text-lg text-black">{event.location}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
